export const CREATE_PROJECTCOMMENTS_REQUEST = 'CREATE_PROJECTCOMMENTS_REQUEST';
export const CREATE_PROJECTCOMMENTS_SUCCESS = 'CREATE_PROJECTCOMMENTS_SUCCESS';
export const CREATE_PROJECTCOMMENTS_FAILURE = 'CREATE_PROJECTCOMMENTS_FAILURE';
export const FETCH_PROJECTCOMMENTS_REQUEST = 'FETCH_PROJECTCOMMENTS_REQUEST';
export const FETCH_PROJECTCOMMENTS_SUCCESS = 'FETCH_PROJECTCOMMENTS_SUCCESS';
export const FETCH_PROJECTCOMMENTS_FAILURE = 'FETCH_PROJECTCOMMENTS_FAILURE';